export const loginOnFacebook = (): Promise<string> =>
  new Promise((resolve, reject) => {
    if (!window.FB) {
      return reject('Facebook SDK is not loaded.');
    }

    window.FB.login(response => {
      response.status !== 'connected' || !response.authResponse?.accessToken
        ? reject('Facebook login failed.')
        : resolve(response.authResponse.accessToken);
    });
  });
